import moment from 'moment'

import { primary_color } from '../../../../Helper/uiHelper'
import { asLogRows, lockerMoveHeadline, LockerLogDifference } from './lockerEditLog'

const MoveBookingLog = ({ data, onExpand, expandedId }) => {
  const updated_data = data?.updated_data && JSON.parse(data.updated_data)
  const original_data = data?.original_data && JSON.parse(data.original_data)
  const headline = lockerMoveHeadline(original_data, updated_data)

  if (expandedId) {
    return (
      <LockerLogDifference
        data={data}
        onExpand={onExpand}
        updated_data={updated_data}
        original_data={original_data}
        headline={headline}></LockerLogDifference>
    )
  }
  return (
    <div className='d-flex align-items-center p-3' style={{ borderBottom: '1px solid #e0e0e0' }}>
      <div>
        <i
          className='fa-solid fa-arrow-up-right-from-square mr-2 cursor-pointer'
          style={{ color: primary_color }}
          onClick={() => {
            onExpand(data?.id)
          }}></i>
      </div>
      <div style={{ flex: 1 }}>
        <span className='font-weight-bold'>{data?.updated_by}</span>
        {headline}
      </div>
      {data?.updated_at && <div>{moment.utc(data?.updated_at).format('MMM D  YYYY, HH:mm')}</div>}
    </div>
  )
}

export default MoveBookingLog
